import styled from 'styled-components'

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 24rem;
  align-items: start;
  gap: 1rem;
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const SidePanel = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
`

export const KV = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: ${(props) => props.theme.textColor};
  b {
    font-weight: 600;
  }
`

export const BigStat = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.textColor};
  small {
    font-size: 12px;
    font-weight: 400;
    color: ${(props) => props.theme.greyText};
    margin-left: 0.5rem;
  }
`

export const Hint = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.greyText};
`

export const EventRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 14px;
  color: ${(props) => props.theme.textColor};
  border-bottom: 1px solid ${(props) => props.theme.colorDividerDefault};
  &:last-child {
    border-bottom: none;
  }
`

export const ModeRow = styled.div`
  display: flex;
  gap: 0.5rem;
`

export const ModeButton = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 14px;
  color: ${(props) => props.theme.textColor};
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  border: 1px solid
    ${(props) => (props.$active ? props.theme.colorOrange : props.theme.colorDividerDefault)};
  background: ${(props) => (props.$active ? props.theme.colorOrange + '22' : 'transparent')};
`

export const TypeChip = styled.span<{ $closed?: boolean }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.$closed ? props.theme.colorRed + '26' : props.theme.colorOrange + '26'};
  color: ${(props) => (props.$closed ? props.theme.colorRed : props.theme.colorOrange)};
`

export const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 12px;
  color: ${(props) => props.theme.greyText};
`

export const LegendDot = styled.span<{ $color: string }>`
  width: 0.75rem;
  height: 0.25rem;
  border-radius: 999px;
  background: ${(props) => props.$color};
`
